module.exports = __webpack_public_path__ + "static/media/status-ativo-icon.a6a1a75f.svg";